import { _ as __makeTemplateObject, d as __assign, a as __extends, b as __awaiter, e as __generator, C as ClientSDKProxyContext } from '../../chunks/chunk-525a49bc.js';
import { Button, Spin } from 'antd';
import React, { Component as Component$1 } from 'react';
import styled from 'styled-components';
import { E as ERROR_NO_SDK_CLIENT, a as ERROR_API_UNEXPECTED_RESULTS } from '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import '../../chunks/chunk-6cec2b98.js';
import { w as withDefaultTheme } from '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';
import 'moment';
import { f as formatDatetime } from '../../chunks/chunk-06cde6d9.js';
import { a as applyThemeFontFamily } from '../../chunks/chunk-ae1accbb.js';
import { C as ComplexString } from '../../chunks/chunk-5565c056.js';

var defaultStrings = {
    noDescription: 'No description',
    start: 'Start',
    end: 'End',
    noStartTime: 'Unknown',
    noEndTime: 'Ongoing',
    details: 'Explore event details',
    metadataSummary: 'Contains {{count}} additional pieces of data',
};
var EventPreviewView = function (_a) {
    var onShowDetails = _a.onShowDetails, event = _a.event, _b = _a.strings, strings = _b === void 0 ? {} : _b, _c = _a.hideProperties, hideProperties = _c === void 0 ? [] : _c, _d = _a.styles, styles = _d === void 0 ? {} : _d;
    var lang = __assign(__assign({}, defaultStrings), strings);
    var startTime = event.startTime, endTime = event.endTime, description = event.description, metadata = event.metadata, type = event.type, subtype = event.subtype;
    var noDescription = lang.noDescription, start = lang.start, end = lang.end, details = lang.details, metadataSummary = lang.metadataSummary, noStartTime = lang.noStartTime, noEndTime = lang.noEndTime;
    var startDate = formatDatetime(startTime, noStartTime);
    var endDate = formatDatetime(endTime, noEndTime);
    var metadataCount = metadata ? Object.keys(metadata).length : 0;
    return (React.createElement(Container, { key: "container", style: styles.wrapper },
        React.createElement(EventType, { style: styles.eventType }, [
            hideProperties.includes('type') ? '' : type,
            hideProperties.includes('subtype') ? '' : subtype,
        ]
            .filter(Boolean)
            .join(' / ')),
        !hideProperties.includes('description') && (React.createElement(EventTitle, { style: styles.description }, description || noDescription)),
        React.createElement(EventDetailsBlock, { style: styles.times },
            !hideProperties.includes('startTime') && (React.createElement("p", null,
                start,
                ": ",
                startDate)),
            !hideProperties.includes('endTime') && (React.createElement("p", null,
                end,
                ": ",
                endDate))),
        !hideProperties.includes('metadata') && (React.createElement(EventDetailsBlock, { style: styles.metadata },
            React.createElement(ComplexString, { input: metadataSummary, count: metadataCount }))),
        onShowDetails && (React.createElement(Button, { htmlType: "button", type: "primary", onClick: function () { return onShowDetails(event); }, style: styles.button }, details))));
};
var EventTitle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1.4rem;\n  padding-bottom: 16px;\n"], ["\n  font-size: 1.4rem;\n  padding-bottom: 16px;\n"])));
var EventType = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 1.2rem;\n  color: ", ";\n  padding-bottom: 8px;\n"], ["\n  font-size: 1.2rem;\n  color: ", ";\n  padding-bottom: 8px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gearbox.textColorAccent;
});
var EventDetailsBlock = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 1.1rem;\n  padding-bottom: 16px;\n  p {\n    margin: 0;\n  }\n"], ["\n  font-size: 1.1rem;\n  padding-bottom: 16px;\n  p {\n    margin: 0;\n  }\n"])));
var Container = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  padding: 16px;\n  width: 300px;\n  background-color: ", ";\n  border-radius: 4px;\n  border: 1px solid ", ";\n  margin-top: 32px;\n  ", ";\n"], ["\n  color: ", ";\n  padding: 16px;\n  width: 300px;\n  background-color: ", ";\n  border-radius: 4px;\n  border: 1px solid ", ";\n  margin-top: 32px;\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gearbox.textColorSecondary;
}, function (_a) {
    var theme = _a.theme;
    return theme.gearbox.containerColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.gearbox.containerBorderColor;
}, function (_a) {
    var theme = _a.theme;
    return applyThemeFontFamily(theme.gearbox);
});
var Component = withDefaultTheme(EventPreviewView);
Component.displayName = 'EventPreviewView';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var LoadingSpinner = function () { return (React.createElement(SpinContainer, null,
    React.createElement(Spin, null))); };
var EventPreview = /** @class */ (function (_super) {
    __extends(EventPreview, _super);
    function EventPreview(props) {
        var _this = _super.call(this, props) || this;
        _this.isComponentUnmount = false;
        _this.state = {
            event: null,
        };
        return _this;
    }
    EventPreview.prototype.componentDidMount = function () {
        this.client = this.context(EventPreview.displayName || '');
        if (!this.client) {
            console.error(ERROR_NO_SDK_CLIENT);
            return;
        }
        this.loadEvent();
    };
    EventPreview.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.eventId !== this.props.eventId) {
            this.setState({ event: null });
            this.loadEvent();
        }
    };
    EventPreview.prototype.componentWillUnmount = function () {
        this.isComponentUnmount = true;
    };
    EventPreview.prototype.loadEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var events;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.events.retrieve([
                            { id: this.props.eventId },
                        ])];
                    case 1:
                        events = _a.sent();
                        if (events.length !== 1) {
                            console.error(ERROR_API_UNEXPECTED_RESULTS);
                            return [2 /*return*/];
                        }
                        if (!this.isComponentUnmount) {
                            this.setState({ event: events[0] });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EventPreview.prototype.render = function () {
        var _a = this.props, hideLoadingSpinner = _a.hideLoadingSpinner, onShowDetails = _a.onShowDetails, hideProperties = _a.hideProperties, strings = _a.strings, styles = _a.styles;
        var event = this.state.event;
        if (!event) {
            return hideLoadingSpinner ? null : React.createElement(LoadingSpinner, null);
        }
        return (React.createElement(Component, { styles: styles, event: event, onShowDetails: onShowDetails, hideProperties: hideProperties, strings: strings }));
    };
    EventPreview.displayName = 'EventPreview';
    EventPreview.contextType = ClientSDKProxyContext;
    EventPreview.defaultProps = {
        strings: defaultStrings,
    };
    return EventPreview;
}(Component$1));
var SpinContainer = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  display: flex;\n  width: 300px;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  width: 300px;\n  align-items: center;\n  justify-content: center;\n"])));
var templateObject_1$1;

export { EventPreview };
